/**
 * Directive for the Edit Portal Page Description section.
 * Do not change the directive name here as its used dynamically in the view to load multiple instances
 */
SUGApp.directive("sugDescription", function() {
    return({
        restrict: "A",
        templateUrl: "/view/tools/portals/dspSectionDescription.html",
        scope: {
            data: '=',
            section: '='
        },
        controller: ['$scope','$filter','$timeout','SUGUtilities','errorService',
            function($scope , $filter , $timeout , SUGUtilities , errorService) {
            // $scope refers to scope of this perticular directive instance.
            //init error service
            $scope.es = errorService;
            $scope.es.init();

            /* Form Elements */
            $scope.frmObj = {

            };

            /* Text Strings */
            $scope.strings = {

            };

            /**
             * Listen for the files save event from the slide out so you can update the instance view
             */
            $scope.$on('portal_savedescription', function (evt,val) {
                //if the event has a valid value and is for this specific section instance, then update view
                if(    typeof val === "object"
                    && typeof val.sectionId !== 'undefined'
                    && typeof val.descSectionContent !== 'undefined' && val.descSectionContent.length
                    && val.sectionId == $scope.section.id)
                {
                    //descSectionContent is the updated JSON string
                    $scope.section.sectioncontent = val.descSectionContent;
                    parseData();
                }
            });

            //Set dynamic disable and processing vars so you only impact a specific directive instance
            $scope['frmDisableField'+$scope.section.id] = false;
            $scope['isProcessing'+$scope.section.id] = false;

            // Handler for Processing Status
            $scope.$on('isProcessingDescription', function (event, objProcessing) {
                //Verify the event has a valid object and is for this specific section instance
                if(    typeof objProcessing === "object"
                && typeof objProcessing.sectionId !== 'undefined'
                && typeof objProcessing.isprocessing !== 'undefined'
                && objProcessing.sectionId == $scope.section.id){
                    $scope['isProcessing'+$scope.section.id] = objProcessing.isprocessing;
                    disableForm(objProcessing.isprocessing);
                }
            });

            //manage disabling the form
            var disableForm = function (blnDisabled) {
                $scope['frmDisableField'+$scope.section.id] = blnDisabled;
            };


            /**
             * Method loads the info for the section directive from main data model
             */
            var parseData = function(){
                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessingDescription', { 'sectionId': $scope.section.id, 'isprocessing': true });

                $scope.description = {};
                $scope.description.content = JSON.parse($scope.section.sectioncontent);

                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessingDescription', { 'sectionId': $scope.section.id, 'isprocessing': false });
            };

            parseData();
        }] // end controller

    }); // END return
});